import { SmartComponentPropertyDetailsSave } from "./smart-component-property-details-save";

export class SmartComponentPropertySave {
    public id: number = 0;
    public skills: SmartComponentPropertyDetailsSave[] = [];
    public idSmartComponentKind: number = 0;
  
    constructor(controlType?: any) {
      // used for assign type to instance of object
      if (controlType) {
        Object.assign(this, controlType);
      }
    }
  }